import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSponsorsByEventId } from '../../api/eventApi';
import { getImage } from '../../utils/helper.ts';
import { highlightTitle } from '../../utils/htmlHelper.tsx';


interface AboutProps {
    landingPageData: any; 
    label: string;
          
  }
 
const Sponsors:React.FC <AboutProps> = ({landingPageData,label}) => {
  const eventData = useSelector((state: any) => state.eventData);
  const [eventSponsors, setEventSponsors] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchSponsors = async () => {
      setLoading(true);
      try {
        const sponsors = await getSponsorsByEventId(eventData._id);
        setEventSponsors(sponsors);
      } finally {
        setLoading(false);
      }
    };

    if (eventData?._id) {
      fetchSponsors();
    }
  }, [eventData]);

  if (loading || eventSponsors.length === 0) {
    return null;
  }
  const text = landingPageData?.sponsor_text || '';
  const eventTitle = eventData?.title || '';


  return (
    <div className="single-section silver-bg pricing-area" id="sponsors">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* Section heading */}
            <div className="section-heading">
              <h2 className="section-title" style={{
   '--before-bg': eventData.primary_color
  }}>{label}</h2>
              <p className="section-description col-lg-12 col-md-10 col-sm-12">
               {highlightTitle(text, eventTitle,eventData?.primary_color)}
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {eventSponsors.map((sponsor, index) => (
            <div className="col-md-2 mb-4" key={index}>
              <div className="client-item text-center">
                
                <div className="client-img">
                    <img src={getImage(sponsor.logo)} alt={sponsor.name}   width="160px"/>
                </div>

                {/* <header>
                  <div className="strongP" style={{ color: landingPageData?.landing_page_theme_color }}>{sponsor.name}</div>
                </header> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sponsors;
